import React from 'react';

export const CameroonFlag: React.FC<{ className?: string }> = ({ className = 'w-5 h-3.5' }) => {
  return (
    <div
      className={`inline-flex rounded-xs overflow-hidden shadow-2xs shrink-0 border border-black/10 ${className}`}
      title="Cameroon (CM)"
      style={{ aspectRatio: '3 / 2' }}
    >
      <div className="w-1/3 h-full bg-[#007a3d]" />
      <div className="w-1/3 h-full bg-[#ce1126] relative flex items-center justify-center">
        {/* Yellow 5-pointed star */}
        <svg
          viewBox="0 0 24 24"
          fill="#fcd116"
          className="w-2.5 h-2.5"
        >
          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
        </svg>
      </div>
      <div className="w-1/3 h-full bg-[#fcd116]" />
    </div>
  );
};
